export default {
    nl: {
        featureDiscovery: {
            steps: {
                start: {
                    title: 'We hebben een nieuwe gebruikerservaring voor je! 🎉',
                    description:
                        'Zo hebben we de manier van navigeren flink aangepakt zodat je nog makkelijker je weg vindt in de applicatie. <br /> <br /> Zullen we het je even laten zien?',
                },
                navigationRail: {
                    title: 'Navigatiebalk',
                    description:
                        'Aan de zijkant van de applicatie introduceren we een nieuwe visuele manier van navigeren. Ga er met je muis overheen om de onderliggende items weer te geven!',
                },
                mobileMenuButton: {
                    title: 'Mobiele menu',
                    description:
                        ' We noemen dit menu het hamburgermenu. Wist je dat? <br />Via dit icoon kom je snel bij alle belangrijke pagina’s.',
                },
                navigationDrawer: {
                    title: 'Geopend menu',
                    description:
                        'Hier vind je alle belangrijke pagina’s waar je naartoe kunt navigeren. Soms heeft een categorie ook subpagina’s.Zo houden we alles overzichtelijk.',
                },
                appSwitcher: {
                    title: 'Snel schakelen',
                    description:
                        'Maak je gebruik van meerdere SDB applicaties, dan kun je hier snel wisselen. Tip: open ze in een nieuw tabblad om in meerdere applicaties tegelijk te werken!',
                },
                breadcrumbs: {
                    title: 'Kruimelpad',
                    description:
                        'Boven in het scherm kun je altijd zien waar je bent in de applicatie. Je kunt er zelfs mee terug navigeren door er op te klikken!',
                },
                notifications: {
                    title: 'Notificaties',
                    description:
                        'Een nieuw Notificatiecentrum waar je direct het onderwerp van de melding kunt zien. Je kunt er dan ook direct naartoe navigeren!',
                },
                profileMenuButton: {
                    title: 'Profielmenu',
                    description:
                        'Daarnaast tonen we een profielmenu met toegang tot je gegevens en helpartikelen. Nog geen profielfoto? Stel deze hier in!',
                },
                restartButton: {
                    title: 'Einde 🎯',
                    description:
                        'Wil je de uitleg nog eens bekijken? Start deze opnieuw op onder je profielmenu. <br /><br />Werk ze!',
                },
            },
            previous: 'Vorige',
            next: 'Volgende',
            done: 'Klaar',
            pagination: 'Pagina {{currentStep}} van {{totalSteps}}',
        },
        help: 'Help',
        releaseNotes: 'Productnieuws',
        statusPage: 'Statuspagina',
        messages: 'Berichten',
        noMessages: 'Geen nieuwe berichten',
        myInformation: 'Mijn gegevens',
        message: {
            // TODO: fix this syntax
            header: `{ created, select,
                undefined {}
                other {{created} - }
            }{ sender, select,
                undefined {Systeembericht}
                other {{sender}}
            }{ autoGenerated, select,
                true { (automatisch verzonden)}
                other {}
            }`,
            to: `Aan: {{recipients}}`,
            subjectElearningNotificationMessage: 'afronding e-learning bericht',
            achievementMessagePassed: `Gebruiker ''{{identityDisplayName}}'' is geslaagd voor de e-learningmodule ''{{catalogItemName}}''`,
            achievementMessageFinished: `Gebruiker ''{{identityDisplayName}}'' heeft de e-learningmodule ''{{catalogItemName}}'' succesvol afgerond`,
            assessorAppointmentMade: `Er is een afspraak gemaakt voor gebruiker ''{{studentDisplayName}}'' op ''{{dateTime}}'' om de volgende activiteit af te laten toetsen: ''{{activityDescription}}''`,
            assessorAppointmentRejected: `Het beoordelingsverzoek voor activiteit ''{{activityDescription}}'' op ''{{dateTime}}'' is afgewezen door ''{{assessorDisplayName}}''`,
            assessorAppointmentRemoved: `De afspraak van gebruiker ''{{studentDisplayName}}'' op ''{{dateTime}}'' voor activiteit ''{{activityDescription}}'' is verwijderd`,
            assessorAppointmentMadeSubject: `Toetsafspraak gemaakt`,
            assessorAppointmentRemovedSubject: `Toetsfspraak verwijderd`,
            catalogAuthRequestPermissionSubjectLearningplan:
                '{{studentDisplayName}} heeft een aanvraag voor e-learning {{displayName}} gedaan.',
            catalogAuthRequestPermissionSubjectClassroom:
                '{studentDisplayName} heeft een aanvraag voor de klassikale opleiding {{displayName}} die start op {{planningStart}} gedaan.',
            catalogAuthRequestPermissionBody: `Ga op het dashboard naar ''Autorisatie aanvragen'' om de aanvraag af te handelen.`,
            catalogAuthRequestBodyLearningPlanAccepted: `Je aanvraag om e-learning ''{{displayName}}'' te volgen is geaccepteerd`,
            catalogAuthRequestBodyLearningPlanAcceptedRemark: `Je aanvraag om e-learning ''{{displayName}}'' te volgen is geaccepteerd. Je manager heeft de volgende opmerking toevoegd: {{managerRemark}}`,
            catalogAuthRequestBodyLearningPlanRejected: `Je aanvraag om e-learning ''{{displayName}}'' te volgen is geweigerd`,
            catalogAuthRequestBodyLearningPlanRejectedRemark: `Je aanvraag om e-learning ''{{displayName}}'' te volgen is geweigerd. Je manager heeft de volgende opmerking toevoegd: {{managerRemark}}`,
            catalogAuthRequestBodyLearningPlanDeleted: `Je aanvraag om e-learning ''{{displayName}}'' te volgen is verwijderd`,
            catalogAuthRequestBodyLearningPlanDeletedRemark: `Je aanvraag om e-learning ''{{displayName}}'' te volgen is verwijderd. Je manager heeft de volgende opmerking toevoegd: {{managerRemark}}`,
            catalogAuthRequestBodyLearningPlanUnknown: `Je aanvraag om e-learning ''{{displayName}}'' te volgen is status onbekend`,
            catalogAuthRequestBodyLearningPlanUnknownRemark: `Je aanvraag om e-learning ''{{displayName}}'' te volgen is status onbekend. Je manager heeft de volgende opmerking toevoegd: {{managerRemark}}`,
            catalogAuthRequestPermissionRevoked: `De aanvrager heeft de autorisatie voor ''{{displayName}}'' ingetrokken.`,
            catalogAuthRequestBodyClassroomAccepted: `Je aanvraag om klassikale training ''{{displayName}}'' die start op {{planningStart}} te volgen is geaccepteerd`,
            catalogAuthRequestBodyClassroomAcceptedRemark: `Je aanvraag om klassikale training ''{{displayName}}'' die start op {{planningStart}} te volgen is geaccepteerd. Je manager heeft de volgende opmerking toevoegd: {{managerRemark}}`,
            catalogAuthRequestBodyClassroomRejected: `Je aanvraag om klassikale training ''{{displayName}}'' die start op {{planningStart}} te volgen is geweigerd`,
            catalogAuthRequestBodyClassroomRejectedRemark: `Je aanvraag om klassikale training ''{{displayName}}'' die start op {{planningStart}} te volgen is geweigerd. Je manager heeft de volgende opmerking toevoegd: {{managerRemark}}`,
            catalogAuthRequestBodyClassroomDeleted: `Je aanvraag om klassikale training ''{{displayName}}'' die start op {{planningStart}} te volgen is verwijderd`,
            catalogAuthRequestBodyClassroomDeletedRemark: `Je aanvraag om klassikale training ''{{displayName}}'' die start op {{planningStart}} te volgen is verwijderd. Je manager heeft de volgende opmerking toevoegd: {{managerRemark}}`,
            catalogAuthRequestBodyClassroomUnknown: `Je aanvraag om klassikale training ''{{displayName}}'' die start op {{planningStart}} te volgen is status onbekend`,
            catalogAuthRequestBodyClassroomUnknownRemark: `Je aanvraag om klassikale training ''{{displayName}}'' die start op {{planningStart}} te volgen is status onbekend. Je manager heeft de volgende opmerking toevoegd: {{managerRemark}}`,
            catalogAuthRequestPermissionAccepted: `Aanvraag voor ''{{displayName}}'' is geaccepteerd.`,
            catalogAuthRequestPermissionRejected: "Aanvraag voor '{{displayName}}' is geweigerd.",
            catalogAuthRequestPermissionDeleted: `Aanvraag voor ''{{displayName}}'' is verwijderd.`,
            catalogAuthRequestPermissionUnknown: `Aanvraag voor ''{{displayName}}'' is onbekend.`,
            catalogAuthRequestBodyRevokedByUser: `Gebruiker ''{{studentDisplayName}}'' heeft de autorisatieaanvraag voor ''{{displayName}}'' ingetrokken.`,
            new: 'Bericht aan gebruiker',
            newClass: 'Bericht aan cursusgroep',
            newDepartment: 'Bericht aan afdeling',
            filterByMessage: 'Filteren op bericht',
            searchSubject: 'Zoek op onderwerp',
            filterBySender: 'Filteren op afzender',
            originalMessageInfo: 'Op {{date}} heeft {{sender}} het volgende geschreven:',
            Received: 'Ontvangen',
            Sent: 'Verzonden',
            Settings: 'Instellingen',
            settings: {
                admin: {
                    title: 'Berichtenbox instellingen',
                    description:
                        'Stel hieronder de standaard berichtenbox instellingen in voor alle medewerkers. De ingestelde standaard wordt voor iedereen gehanteerd, behalve voor medewerkers die hun persoonlijke instellingen hebben aangepast in hun eigen berichtenbox.',
                },
                title: 'Mijn berichtenbox instellingen',
                emailSummary: {
                    title: 'E-mail samenvatting',
                    subtitle:
                        'Ontvang een overzicht van het aantal ongelezen berichten in de berichtenbox',
                },
                emailNotification: {
                    title: 'E-mail notificatie',
                    newMessages: 'Nieuwe berichten ook per e-mail ontvangen',
                    Expiringskill: 'Verlopende bekwaamheid',
                    skillExpiration:
                        'Notificatie bij verlopende bekwaamheid ook per e-mail ontvangen',
                },
                frequency: 'Frequentie e-mail samenvatting',
                noEmail: 'Nooit / geen samenvatting',
                none: 'Nooit / geen samenvatting',
                daily: 'Dagelijkse samenvatting',
                weekly: 'Wekelijkse samenvatting',
                monthly: 'Maandelijkse samenvatting',
            },
            skills: {
                expirationNotification: {
                    subject: `Bekwaamheden update`,
                    body: `Beste deelnemer,\n
                { expired, select,
                    0 {}
                    other {Op dit moment {expired, select, 1 {is er 1 bekwaamheid} other {zijn er {expired} bekwaamheden}} verlopen.}
                }
                { expiring, select,
                    0 {}
                    other {In de periode tot {until} {expiring, select, 1 {gaat er nog 1 bekwaamheid} other {gaan er nog {expiring} bekwaamheden}} verlopen.}
                }
                { new, select,
                    0 {}
                    other {Sinds de laatste update {new, select, 1 {is er 1 bekwaamheid} other {zijn er {new} bekwaamheden}} aan jou toegewezen.}
                }

                        Je kunt jouw bekwaamheden bekijken in je portfolio.
                    `,
                },
            },
        },
        modules: {
            accessManagement: {
                activatedRights: 'Geactiveerde rechten',
                applicationPart: 'Applicatie onderdeel',
                descriptions: `{key, select,
                    roles_and_rights {Rollen en rechten}
                    roles_and_rights_manage_roles {Beheer rollen}
                    roles_and_rights_manage_assignments {Beheer toewijzingen}
                    classroom {Classroom}
                    classroom_manage_courses {Beheer opleidingen}
                    classroom_manage_schedules {Beheer planningen}
                    classroom_manage_enrollments {Beheer inschrijvingen}
                    classroom_manage_presence {Beheer presentie}
                }`,
            },
            errors: `{error, select,
                duplicate_name {Er is al een rol met deze naam}
                no_name_provided {Er is geen rolnaam opgegeven}
                other {Er is een fout opgetreden}
            }`,
            adminMenu: {
                labels: {
                    general: 'Instellingen',
                    catalog: 'Catalogus',
                    compositionmanagement: 'E-learning',
                    scormmanagement: 'Scorm',
                    elearningmanagement: 'E-learning',
                    evaluations: 'Evaluaties',
                    definities: 'Dossieritems',
                    classroom: 'Klassikaal',
                    skills: 'Bekwaamheden',
                    certificates: 'Certificaten',
                    usermanagement: 'Gebruikers',
                    examinermanagement: 'Toetsers',
                    importmanagement: 'Import',
                    rolesandrights: 'Rechten',
                    maillogoverview: 'E-mail logging',
                },
            },
            mainMenu: {
                labels: {
                    start: 'Start',
                    catalog: 'Catalogus',
                    departments: 'Afdelingen',
                    skills: 'Bekwaamheden',
                    functions: 'Functies',
                    workLearningMethods: ' Werkvormen',
                    myMinerva: 'Portfolio',
                    search: 'Zoeken',
                    administration: 'Beheer',
                },
            },
            portfolioMenu: {
                labels: {
                    skills: 'Bekwaamheden',
                    assigned: 'Toegewezen opleidingen',
                    results: 'Resultaten',
                    dossier: 'Dossier',
                    accreditations: 'Accreditaties',
                    activities: 'Activiteiten',
                    interests: 'Interesselijst',
                    departments: 'Afdelingen',
                    profile: 'Profiel',
                    evaluations: 'Evaluaties',
                    assessors: 'Toetsmomenten',
                },
            },
        },
        notifications: 'Notificaties',
        profile: 'Profiel',
        restartFeatureDiscovery: 'Introductie opnieuw starten',
        signOut: 'Uitloggen',
        uservoiceIcon: 'Wensen doorgeven',
    },
    en: {
        featureDiscovery: {
            steps: {
                start: {
                    title: 'We have a new user experience for you! 🎉',
                    description:
                        'We have redesigned the navigation to make it easier for you to find your way around the application. <br /> <br /> Let us show you!',
                },
                navigationRail: {
                    title: 'Navigation bar',
                    description:
                        'We introduce a new visual way of navigating the application. Hover over it to see the underlying items!',
                },
                mobileMenuButton: {
                    title: 'Mobile menu',
                    description:
                        ' This is the hamburger menu. Did you know that? <br />Via this icon you can quickly access all important pages.',
                },
                navigationDrawer: {
                    title: 'Open menu',
                    description:
                        'Here you can find all important pages where you can navigate. Sometimes a category also has subpages. So we keep everything organized.',
                },
                appSwitcher: {
                    title: 'Quick switch',
                    description:
                        'If you use multiple SDB applications, you can switch between them here. Tip: open them in a new tab to work in multiple applications at the same time!',
                },
                breadcrumbs: {
                    title: 'Breadcrumbs',
                    description:
                        'At the top of the screen, you can always see where you are in the application. You can even navigate back by clicking on them!',
                },
                notifications: {
                    title: 'Notifications',
                    description:
                        'A new notifications center where you can see the subject of the message directly. You can also navigate directly to it!',
                },
                profileMenuButton: {
                    title: 'Profile menu',
                    description:
                        'In addition, we show a profile menu with access to your data and help articles. No profile picture? Set it here!',
                },
                restartButton: {
                    title: 'End 🎯',
                    description:
                        'Want to see this explanation again? Start it again under your profile menu. <br /> <br /> Good luck!',
                },
            },
            previous: 'Previous',
            next: 'Next',
            done: 'Done',
            pagination: 'Page {{currentStep}} of {{totalSteps}}',
        },
        help: 'Help',
        releaseNotes: 'Release notes',
        statusPage: 'Status page',
        messages: 'Messages',
        noMessages: 'No new messages',
        myInformation: 'My information',
        message: {
            // TODO: fix this syntax
            header: `{ created, select,
                undefined {}
                other {{created} - }
            }{ sender, select,
                undefined {System message}
                other {{sender}}
            }{ autoGenerated, select,
                true { (sent automatically)}
                other {}
            }`,
            to: `To: {{recipients}}`,
            subjectElearningNotificationMessage: 'e-learning completed message',
            achievementMessagePassed: `User ''{{identityDisplayName}}'' has passed the e-learning module ''{{catalogItemName}}''`,
            achievementMessageFinished: `User ''{{identityDisplayName}}'' has successfully completed the e-learning module ''{{catalogItemName}}''`,
            assessorAppointmentMade: `An appointment was made for user ''{{studentDisplayName}}'' on ''{{dateTime}}'' to assess the following activity: ''{{activityDescription}}''`,
            assessorAppointmentRejected: `The assessment request for activity ''{{activityDescription}}'' on ''{{dateTime}}'' is rejected by ''{{assessorDisplayName}}''`,
            assessorAppointmentRemoved: `The appointment for user ''{{studentDisplayName}}'' on ''{{dateTime}}'' for activity ''{{activityDescription}}'' has been removed`,
            assessorAppointmentMadeSubject: `Assessment appointment created`,
            assessorAppointmentRemovedSubject: 'Assessment appointment removed',
            catalogAuthRequestPermissionSubjectLearningplan:
                "{{studentDisplayName}} has requested permission for elearning module '{{displayName}}'.",
            catalogAuthRequestPermissionSubjectClassroom: `{{studentDisplayName}} has requested permission for the classical training module ''{{displayName}}'' which starts at {{planningStart}}.`,
            catalogAuthRequestPermissionBody: `Go to the dashboard and click ''Authorization requests'' to process the request.`,
            catalogAuthRequestBodyLearningPlanAccepted: `Your request for elearning ''{{displayName}}'' is accepted`,
            catalogAuthRequestBodyLearningPlanAcceptedRemark: `Your request for elearning ''{{displayName}}'' is accepted. Your manager added the following remark: {{managerRemark}}`,
            catalogAuthRequestBodyLearningPlanRejected: `Your request for elearning ''{{displayName}}'' is rejected.`,
            catalogAuthRequestBodyLearningPlanRejectedRemark: `Your request for elearning ''{{displayName}}'' is rejected. Your manager added the following remark: {{managerRemark}}`,
            catalogAuthRequestBodyLearningPlanDeleted: `Your request for elearning ''{{displayName}}'' is deleted.`,
            catalogAuthRequestBodyLearningPlanDeletedRemark: `Your request for elearning ''{{displayName}}'' is deleted. Your manager added the following remark: {{managerRemark}}`,
            catalogAuthRequestBodyLearningPlanUnknown: `Your request for elearning ''{{displayName}}'' is status unknown.`,
            catalogAuthRequestBodyLearningPlanUnknownRemark: `Your request for elearning ''{{displayName}}'' is status unknown. Your manager added the following remark: {{managerRemark}}`,
            catalogAuthRequestPermissionRevoked: `The user revoked the authorization request for ''{{displayName}}''.`,
            catalogAuthRequestBodyClassroomAccepted: `Your request for classical training ''{{displayName}}'' which starts at {{planningStart}} is accepted.`,
            catalogAuthRequestBodyClassroomAcceptedRemark: `Your request for classical training ''{{displayName}}'' which starts at {{planningStart}} is accepted. Your manager added the following remark: {{managerRemark}}`,
            catalogAuthRequestBodyClassroomRejected: `Your request for classical training ''{{displayName}}'' which starts at {{planningStart}} is rejected`,
            catalogAuthRequestBodyClassroomRejectedRemark: `Your request for classical training ''{{displayName}}'' which starts at {{planningStart}} is rejected. Your manager added the following remark: {{managerRemark}}`,
            catalogAuthRequestBodyClassroomDeleted: `Your request for classical training ''{{displayName}}'' which starts at {{planningStart}} is deleted.`,
            catalogAuthRequestBodyClassroomDeletedRemark: `Your request for classical training ''{{displayName}}'' which starts at {{planningStart}} is deleted. Your manager added the following remark: {{managerRemark}}`,
            catalogAuthRequestBodyClassroomUnknown: `Your request for classical training ''{{displayName}}'' which starts at {{planningStart}} is status unknown.`,
            catalogAuthRequestBodyClassroomUnknownRemark: `Your request for classical training ''{{displayName}}'' which starts at {{planningStart}} is status unknown. Your manager added the following remark: {{managerRemark}}`,
            catalogAuthRequestPermissionAccepted: `Your request for ''{{displayName}}'' is accepted.`,
            catalogAuthRequestPermissionRejected: "Your request for '{{displayName}}' is rejected.",
            catalogAuthRequestPermissionDeleted: `Your request for ''{{displayName}}'' is deleted.`,
            catalogAuthRequestPermissionUnknown: `Your request for ''{{displayName}}'' is status unknown.`,
            catalogAuthRequestBodyRevokedByUser: `User ''{{studentDisplayName}}'' revoked the authorization request for ''{{displayName}}''`,
            filterByMessage: 'Filter by message',
            searchSubject: 'Search on subject',
            filterBySender: 'Filter by sender',
            originalMessageInfo: 'On {date} {sender} wrote:',
            new: 'Message to user',
            newClass: 'Message to coursegroup',
            newDepartment: 'Message to department',
            Received: 'Received',
            Sent: 'Sent',
            Settings: 'Settings',
            settings: {
                admin: {
                    title: 'Message box settings',
                    description:
                        'Set the default message box settings for all users. These settings will apply to all users, except for users who changed their personal settings in their own message box settings.',
                },
                title: 'My messagebox settings',
                emailSummary: {
                    title: 'E-mail summary',
                    subtitle:
                        'Receive an e-mail summary with the number of unread messages in the messagebox',
                },
                emailNotification: {
                    title: 'E-mail notification',
                    newMessages: 'Receive new messages by e-mail',
                    Expiringskill: 'Expiring skill',
                    skillExpiration: 'Receive notification when skills expire by email',
                },
                frequency: 'Email summary frequency',
                noEmail: 'Never / no summary',
                none: 'Never / no summary',
                daily: 'Daily summary',
                weekly: 'Weekly summary',
                monthly: 'Monthly summary',
            },
            skills: {
                expirationNotification: {
                    subject: `Skills update`,
                    body: `Dear participant,\n
            { expired, select,
                0 {}
                other {At the moment {expired, select, 1 {1 skill has} other {{expired} skills have}} expired.}
            }
            { expiring, select,
                0 {}
                other {In the period up to {until}, {expiring} more {expiring, select, 1 {skill} other {skills}} will expire.}
            }
            { new, select,
                0 {}
                other {Since the last update, {new} {new, select, 1 {skill has} other {skills have}} been assigned to you.}
            }

            You can view your skills in your portfolio.
        `,
                },
            },
        },
        modules: {
            adminMenu: {
                labels: {
                    general: 'Settings',
                    catalog: 'Catalog',
                    compositionmanagement: 'E-learning',
                    scormmanagement: 'Scorm',
                    elearningmanagement: 'E-learning',
                    evaluations: 'Evaluations',
                    definities: 'Portfolio items',
                    classroom: 'Classical',
                    skills: 'Skills',
                    certificates: 'Certificates',
                    usermanagement: 'Users',
                    examinermanagement: 'Examiners',
                    importmanagement: 'Import',
                    rolesandrights: 'Rights',
                    maillogoverview: 'E-mail logging',
                },
            },
            mainMenu: {
                labels: {
                    start: 'Start',
                    catalog: 'Catalog',
                    departments: 'Departments',
                    skills: 'Skills',
                    functions: 'Functions',
                    workLearningMethods: 'Working forms',
                    myMinerva: 'Portfolio',
                    search: 'Search',
                    administration: 'Admin',
                },
            },
            portfolioMenu: {
                labels: {
                    skills: 'Skills',
                    assigned: 'Assigned trainings',
                    results: 'Results',
                    dossier: 'Portfolio tasks',
                    accreditations: 'Accreditations',
                    activities: 'Activities',
                    interests: 'Watchlist',
                    departments: 'Departments',
                    profile: 'Profile',
                    evaluations: 'Evaluations',
                    assessors: 'Assessment moments',
                },
            },
        },
        notifications: 'Notifications',
        restartFeatureDiscovery: 'Restart introduction',
        profile: 'Profile',
        signOut: 'Sign out',
        uservoiceIcon: 'Report a wish',
    },
};
